// extracted by mini-css-extract-plugin
export default {"CompactTable":"CompactTable_CompactTable__T01pr","Separator":"CompactTable_Separator__2d4V7"};